export default __webpack_public_path__ + "_/images/app/telegram/telegram-en-1-16ee3a63ad8fb829d873d32ceb05d481cc5bd23295c42b06bd841ba1718e6773.jpg";